import { ButtonText } from 'shared/ui/buttons/buttonText';
import { PayloadAction } from '@reduxjs/toolkit';
import { withAsyncActionFeedback } from 'shared/ui/asyncAction';
import { FC } from 'react';

import { useModal } from 'shared/lib/modal';
import { Confirm } from 'shared/ui/confirm';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';

import { useAppDispatch } from 'shared/lib/store';
import { getWaitingOrders } from 'entities/orders';

import { Filters } from 'shared/lib/pagination';
import { getDateRangeFromToday } from 'shared/lib/datepicker';
import { OrderBookingPerson } from 'entities/orders/model/types';
import { Person } from 'entities/person';

interface OrderDetailRemoveConfirmProps {
	removeFromWaitingList: () => Promise<PayloadAction<unknown> | void>;
	onSuccessFetchData?: (filtersParam?: Filters) => void;
	onClose?: () => void;
	person: Person | OrderBookingPerson;
}

export const OrderDetailRemoveConfirm: FC<OrderDetailRemoveConfirmProps> = ({
	removeFromWaitingList,
	onSuccessFetchData,
	onClose,
	person,
}) => {
  const ActionButtonTextWithFeedback = withAsyncActionFeedback(ButtonContained);

	const { openModal, closeModal } = useModal();
	const dispatch = useAppDispatch();

	const getDateParams = () => {
		const [todayStart, todayEnd] = getDateRangeFromToday(true);
		return {
			dt_start__gte: todayStart.toISOString(),
			dt_end__lte: todayEnd.toISOString(),
			page: 1,
		};
	};

	const handleSuccess = async () => {
		onClose?.();
		dispatch(getWaitingOrders(getDateParams()));
		closeModal();
		onSuccessFetchData?.();
	};

	const handleClick = async () => {
		return removeFromWaitingList();
	};

	return (
		<>
			<Confirm
				title={
					'Вы действительно хотите удалить заявку из листа ожидания?'
				}
				confirmButton={
					<ActionButtonTextWithFeedback
						onClick={handleClick}
						onSuccess={handleSuccess}
						successToastLabel={`Заявка на имя ${person?.name} удалена!`}
					>
						Да, удалить
					</ActionButtonTextWithFeedback>
				}
				cancelButtonLabel="Нет, оставить"
			/>
			<ButtonText color="danger" isFullWidth={true} onClick={openModal}>
				Удалить
			</ButtonText>
		</>
	);
};
